// extracted by mini-css-extract-plugin
export default {"sectionHeader":"_d73105cb","sectionSubheader":"_53ecc6cf"};